import { RenovationStoreService } from '@hb/modules/property/renovation-part/renovation-store.service';
import { ExtraInformationComponent } from '@hb/modules/global/tip/extra-information.component';
import { NextButtonComponent } from '@hb/modules/global/button';

import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'renovation-tip',
    templateUrl: './renovation-tip.component.html',
    standalone: true,
    imports: [ExtraInformationComponent, ApContentModule, FormsModule, ReactiveFormsModule, ApRadioModule, NextButtonComponent]
})
export class RenovationTipComponent {
    private readonly store = inject(RenovationStoreService);

    nextQuestion(): void {
        this.store.setRenovationTipFinished();
    }
}
